import api from "./api";

export function getContactFormEntries(page = 1, limit = 10, search = "") {
  return api.get(
    `/contactformentry?page=${page}&limit=${limit}&search=${search}`
  );
}

export function deleteContactFormEntry(id) {
  return api.delete(`/contactformentry/${id}`);
}

export function getContactFormEntryById(id) {
  return api.get(`/contactformentry/${id}`);
}
